import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    SettingType, BlockType, Define, ValidationMessage, TibboDataType, SettingOption, CodeBlock,
} from '@appblocks/codegeneration/types';
import Tibbits from '@appblocks/codegeneration/Tibbits';
import General from '@appblocks/codegeneration/Features/General/General';

export default class ArduinoGeneral extends BaseFeature {
    constructor() {
        super();
        this.name = 'General';
        this.id = 'general';

        this.files = [];
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];

        const INTERFACE_SWITCHING = this.getSettingValue('INTERFACE_SWITCHING') === '1';
        const DEFAULT_INTERFACE = this.getSettingValue('DEFAULT_INTERFACE');


        return blocks;
    }
}
